module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#facebook",
      toString: function () {
        return this.url;
      }
    }